import { render, staticRenderFns } from "./EmailVerify.pug?vue&type=template&id=26a1d328&scoped=true&lang=pug&"
import script from "./EmailVerify.vue?vue&type=script&lang=js&"
export * from "./EmailVerify.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerify.scss?vue&type=style&index=0&id=26a1d328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a1d328",
  null
  
)

export default component.exports